import React from 'react';

import styled from '@emotion/styled';

import CollapsableControlIcon from '../Icons/CollapsableControlIcon';

interface CollapsableControlProps {
  isCollapse: boolean;
  setIsCollapse: (...args: any) => void;
}

const CollapsableControl: React.FC<CollapsableControlProps> = ({
  isCollapse,
  setIsCollapse,
}) => {
  return (
    <Control onClick={() => setIsCollapse(!isCollapse)}>
      <CollapsableControlIcon />
    </Control>
  );
};

export default CollapsableControl;

const Control = styled.div`
  display: flex;
  cursor: pointer;
`;
